import { MediaKit } from '@generated/components/MediaKit';
import { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

const READER = 'https://files-public.monday.com/use1/0a431c74-21ab-4ac0-98e7-30dfcaa4953a/Mom.JPG';
const READER2 = 'https://files-public.monday.com/use1/3a72ceef-8879-4fa4-b657-6cc3f6ee6a8d/IMG_0918.JPG';
function ReaderPhoto({ src, alt, className = '' }: { src: string; alt: string; className?: string }) {
  return <img src={src} alt={alt} className={`aspect-square w-[130px] shrink-0 border border-foreground object-cover object-top sm:w-[160px] md:w-[180px] ${className}`} />;
}

export function WhyLocal({ onAdvertise }: { onAdvertise?: () => void }) {
  const [showList, setShowList] = useState(true);
  const toggle = (
    <button type="button" onClick={() => setShowList((s) => !s)} aria-expanded={showList} className="mt-4 inline-flex min-h-11 items-center gap-2 bg-foreground px-5 text-sm font-semibold text-background hover:opacity-90">
      {showList ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}{showList ? "Close the media kit" : "See our informative media kit for an overview"}
    </button>
  );
  return (
    <section className="mb-10 mt-10 border-y-4 border-double border-foreground pb-6 pt-3">
      <div className="grid grid-cols-2 items-center justify-items-center gap-4 sm:grid-cols-[auto_1fr_auto] sm:gap-6">
        <ReaderPhoto src={READER} alt="A longtime reader smiling on her sofa, holding up a copy of the Red Hook Star-Revue" />
        <div className="order-last col-span-2 text-center sm:order-none sm:col-span-1">
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">Before you begin</div>
          <h2 className="mt-2 font-[family-name:var(--font-heading)] text-3xl font-semibold leading-tight text-[hsl(var(--brand-blue))]">Local advertising belongs in your marketing toolbox</h2>
          <p className="mx-auto mt-3 max-w-3xl text-base text-muted-foreground">Community newspapers connect businesses with the neighbors who keep them thriving.<br className="hidden sm:inline" /> Our media kit below gives a sense of our mission and what we are all about.</p>
          {!showList && toggle}
        </div>
        <ReaderPhoto src={READER2} alt="A reader in a suit smiling as he reads the Red Hook Star-Revue" />
      </div>
      {showList && <><MediaKit onAdvertise={onAdvertise} /><div className="mt-5 text-center">{toggle}</div></>}
    </section>
  );
}
